import lookups from '@/assets/json/clientLookups.json'
import { useFormStore } from '@/stores/form'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import router from '@/router'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

export default async function () {
  const formStore = useFormStore()

  let { serviceId: serviceTransactionId } = router.currentRoute.value.params
  const { femaleChildrenNaturalizationRequest } = lookups.ServiceTransactions
  const { passportNumber, passportExpiryDate } = formStore.form.values

  if (passportNumber && passportNumber && new Date() - new Date(passportExpiryDate) <= 0) {
    doNotify(
      i18n.global.t('passportExpiredMessageWorning'),
      i18n.global.t('passportExpiredMessageWorning')
    )
    return false
  }
  if (!formStore.extraMap.hasActivePassport) {
    doNotify(i18n.global.t('noActivePassport'), i18n.global.t('noActivePassport'))
    return false
  }

  if (femaleChildrenNaturalizationRequest == serviceTransactionId) {
    if (!formStore.form.values?.relativesInformation?.length) {
      doNotify(
        i18n.global.t('relativesInformationRequired'),
        i18n.global.t('relativesInformationRequired')
      )
      return false
    }
    if (!formStore.form.values?.acknowledgement) {
      doNotify(i18n.global.t('acknowledgementRequired'), i18n.global.t('acknowledgementRequired'))
      return false
    }
  }

  return true
}
